import { actionConditionDecompiler } from 'pages/Communications/ScenarioSetupPage/actionDecompilers/utils/actionConditionDecompiler';
import { defaultDecompilerConditionSettings } from 'pages/Segments/EditSegment/Standard/Conditions/settings/defaultDecompilerConditionSettings';
import { head } from 'lodash';

export const decompilerSegmentCondition = condition => {
    return head(actionConditionDecompiler([condition], defaultDecompilerConditionSettings._selectedTimeInterval._intervalType));
};
